module.exports = __webpack_public_path__ + "static/img/icon1@2x.da2ba7fe.png";